// extracted by mini-css-extract-plugin
export default {"setupMarkdown":"markdown_setupMarkdown__vsgDS"};